import BuyerInfo from './BuyerInfo.component';

export default BuyerInfo;
